import { Helmet } from "react-helmet-async";

function Contact() {
  return (
    <div className="flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-700 px-4 py-16 min-h-[calc(100vh-160px)]">
      <Helmet>
        <title>Contact Me | Luis Torre</title>
        <meta name="description" content="Learn more about Luis Torre, a Computer Engineering graduate working in automation." />
      </Helmet>
      
      <div className="bg-gray-800 p-8 rounded-2xl shadow-lg border border-gray-700 max-w-md w-full text-center">
        <h2 className="text-4xl font-bold text-white mb-4 relative inline-block">Get in Touch
          <span className="absolute left-0 bottom-0 w-full h-1 bg-[#45577a] rounded-full"></span>
        </h2>
        <p className="text-gray-300 mb-6">
          I’d love to hear from you! Whether it’s about tech, or just to say hi 👋
        </p>

        <div className="space-y-4">
          <a
            href="mailto:ljtorrer@gmail.com"
            className="flex items-center justify-center gap-3 p-3 rounded-lg bg-gray-700 hover:bg-gray-600 transition"
          >
            📧
            <span>ljtorrer@gmail.com</span>
          </a>

          <a
            href="https://linkedin.com/in/ljtorrer"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 p-3 rounded-lg bg-blue-700 hover:bg-blue-600 transition"
          >
            🔗
            <span>linkedin.com/in/ljtorrer</span>
          </a>

          <a
            href="https://github.com/ljtorrer"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 p-3 rounded-lg bg-gray-700 hover:bg-gray-600 transition"
          >
            💻
            <span>github.com/ljtorrer</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contact;
